import { SvgIconProps } from "../types";

export const ImageIcon = ({ src, width, height }: SvgIconProps) => (
  <img src={`/img/icons/${src}`} alt={src} width={width} height={height} />
);
